import { apiSlice } from "./apiSlice";

export const gameApiSlice = apiSlice.injectEndpoints({
  tagTypes: [
    "GameCategory",
    "GameItem",
    "GameProvider",
    "GameLaunch",
    "BetHistory",
    "WithdrawPlayerBalanceFromLastPlatform"
  ],
  endpoints: (builder) => ({
    getGameCategory: builder.query({
      query: () => "/game/api/v1/gameCategory/list",
      providesTags: ["GameCategory"],
    }),
    getGameItem: builder.query({
      query: ({ category, offset, providerId, group, keyword, hasProvider }) =>
        hasProvider == false ?
          `/game/api/v1/gameItem/list?category=${category}&offset=${offset}&hasProvider=${hasProvider}`
          : `/game/api/v1/gameItem/list?category=${category}&offset=${offset}&providerId=${providerId}&group=${encodeURIComponent(group)}&keyword=${encodeURIComponent(keyword)}`,
      providesTags: ["GameItem"],
    }),
    getGameProvider: builder.query({
      query: ({ category, isHome }) =>
        `/game/api/v1/gameProvider/list?category=${category}&isHomepage=${isHome}`,
      providesTags: ["GameProvider"],
    }),
    getLaunchGame: builder.query({
      query: ({ id, type, category, isMobile }) =>
        `/game/api/v1/launchGame?id=${id}&type=${type}&category=${category}&isMobile=${isMobile}`,
      providesTags: ["GameLaunch"],
    }),
    listBetHistory: builder.mutation({
      query: (queryBody) => ({
        url: "/game/api/v1/betHistoryGrouped/list",
        method: "POST",
        body: queryBody,
      }),
      providesTags: ["BetHistory"],
    }),
    getGoldenEggDesc: builder.query({
      query: () =>
        `/game/api/v1/getGoldenEggDesc`,
      providesTags: ["GoldenEggDesc"],
    }),
    claimGoldenEgg: builder.mutation({
      query: (queryBody) => ({
        url: "/game/api/v1/claimGoldenEgg",
        method: "POST",
        body: queryBody,
      }),
    }),
    getGoldenEggCost: builder.query({
      query: () =>
        `/game/api/v1/getGoldenEggCost`,
      providesTags: ["GoldenEggCost"],
    }),
    withdrawPlayerBalanceFromLastPlatform: builder.mutation({
      query: ({id}) => ({
        url: "/game/api/v1/withdrawPlayerBalanceFromLastPlatform",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetGameCategoryQuery,
  useLazyGetGameItemQuery,
  useGetGameProviderQuery,
  useLazyGetGameProviderQuery,
  useLazyGetLaunchGameQuery,
  useListBetHistoryMutation,
  useGetGoldenEggDescQuery,
  useClaimGoldenEggMutation,
  useGetGoldenEggCostQuery,
  useWithdrawPlayerBalanceFromLastPlatformMutation
} = gameApiSlice;